import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

type Props = {
  color?: 'minimal' | 'moderate' | 'severe' | 'none'
} & HTMLAttributes<HTMLDivElement>

export const MeasureBadge = ({ color, className, ...props }: Props) => {
  const colorsStyle = {
    'bg-orange-100 text-orange-900': color === 'moderate',
    'bg-gray-100 text-gray-500': color === 'none',
  }
  return (
    <div
      className={cn(
        'rounded-2xl bg-gray-200 px-2.5 py-0.5 text-xs font-bold text-gray-800',
        colorsStyle,
        className
      )}
      {...props}
    />
  )
}
